// Enhance the existing GET filters; without JavaScript the details remains usable.
export function initializeShopFilters(doc = document) {
    const panel = doc.querySelector('[data-almc-filter-panel]');
    if (!panel || panel.dataset.enhanced) return;
    const dialog = doc.createElement('dialog');
    if (typeof dialog.showModal !== 'function') return;
    const content = panel.querySelector('[data-almc-filter-content]');
    const summary = panel.querySelector('summary');
    const trigger = doc.createElement('button');
    trigger.type = 'button';
    trigger.className = summary.className;
    trigger.innerHTML = summary.innerHTML;
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', 'almc-filter-dialog');
    dialog.id = 'almc-filter-dialog';
    dialog.className = 'almc-filter-dialog';
    dialog.setAttribute('aria-labelledby', 'almc-filter-title');
    dialog.append(content);
    doc.body.append(dialog);
    panel.before(trigger);
    panel.hidden = true;
    panel.dataset.enhanced = 'true';
    content.querySelectorAll('[data-almc-filter-close], [data-almc-filter-footer]').forEach(el => { el.hidden = false; });

    let previousOverflow;
    const close = () => { if (dialog.open) dialog.close(); };
    trigger.addEventListener('click', () => {
        previousOverflow = doc.body.style.overflow;
        dialog.showModal();
        doc.body.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
        content.querySelector('[data-almc-filter-close]').focus();
    });
    dialog.addEventListener('close', () => {
        doc.body.style.overflow = previousOverflow ?? '';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => {
        if (event.target.closest('[data-almc-filter-close]')) close();
        if (event.target === dialog) {
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
        }
    });
    // Native dialog handles Escape and traps focus, including on small screens.
    dialog.addEventListener('input', event => {
        if (!event.target.matches('[data-almc-filter-search]')) return;
        const group = event.target.closest('[data-almc-filter-group]');
        const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        const term = normalise(event.target.value);
        let visible = 0;
        group.querySelectorAll('[data-almc-filter-option]').forEach(option => {
            option.hidden = !normalise(option.textContent).includes(term);
            if (!option.hidden) visible++;
        });
        group.querySelector('[data-almc-filter-no-match]').hidden = visible !== 0;
    });
    const refresh = () => {
        const filters = dialog.querySelector('.filtros-familia');
        const count = Number(filters?.dataset.activeCount || 0);
        trigger.querySelector('[data-almc-filter-count]').textContent = count ? `(${count})` : '';
        const result = doc.querySelector('[data-almc-filter-result-count]');
        if (result && filters?.dataset.resultLabel) result.textContent = filters.dataset.resultLabel;
    };
    refresh();
    // The existing family/brand AJAX replaces only these filters and results.
    const filtersSlot = content.querySelector('.almc-filter-scroll');
    new MutationObserver(() => { refresh(); close(); }).observe(filtersSlot, {childList:true});
    window.addEventListener('pagehide', close);
}

if (typeof document !== 'undefined') initializeShopFilters();
